/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ares_Legal_Form_101Inputs */

const cs_ares_legal_form_101 = /** @type {(inputs: Ares_Legal_Form_101Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fyzická osoba podnikající dle živnostenského zákona`)
};

const en_ares_legal_form_101 = /** @type {(inputs: Ares_Legal_Form_101Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Natural person (trade licence)`)
};

/**
* | output |
* | --- |
* | "Natural person (trade licence)" |
*
* @param {Ares_Legal_Form_101Inputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ares_legal_form_101 = /** @type {((inputs?: Ares_Legal_Form_101Inputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ares_Legal_Form_101Inputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ares_legal_form_101(inputs)
	return cs_ares_legal_form_101(inputs)
});